// extracted by mini-css-extract-plugin
export default {"wrapper":"internal_experiences_box-module___wrapper___d541028c","link":"internal_experiences_box-module___link___a9d6a865","line":"internal_experiences_box-module___line___d229d883"};